import m, {MithrilComponent} from '@bitstillery/mithril'
import {rich_text} from '@bitstillery/common/cms/lib/inline_markup'

import type {CmsComponentMeta} from '@bitstillery/common/cms/catalog_meta'

export const paragraphMeta = {
    tier: 'content',
    summary: 'Body-copy paragraph; may contain inline `Text` or `Link`.',
    when_to_use:
        'Body text inside a `Column` or `Section`. `variant` picks the role the line plays on the page: ' +
        '`eyebrow` above a heading, `lead` for an intro, `fine` for small print under it. ' +
        'Inline markup in a placeholder translation (`<i>`, `<b>`, `<br>`, `<a href>`) is rendered.',
    example: `
    <Paragraph variant="lead">We connect wholesalers with stock they can trust.</Paragraph>
    `,
    showcase: `
    <Column>
        <Paragraph variant="eyebrow">Wholesale spirits</Paragraph>
        <Heading level={2}>Stock you can trust</Heading>
        <Paragraph variant="lead">We connect wholesalers with stock they can trust.</Paragraph>
        <Paragraph>Every offer is checked before it reaches the portal.</Paragraph>
        <Paragraph variant="fine">Prices exclude excise and VAT.</Paragraph>
    </Column>
    `,
} satisfies CmsComponentMeta

export interface ParagraphAttrs {
    /**
     * The role the line plays around the body copy: `eyebrow` — small tracked kicker above a `Heading` ·
     * `lead` — larger intro paragraph · `fine` — small print (disclaimer, caption, footnote).
     */
    variant?: 'eyebrow' | 'lead' | 'fine'
}

/** Body copy. Children may contain inline `Text` / `Link`. */
export class Paragraph extends MithrilComponent<ParagraphAttrs> {
    view(vnode: m.Vnode<ParagraphAttrs>) {
        const variant = vnode.attrs.variant
        return <p className={variant ? `cms-paragraph cms-paragraph-${variant}` : 'cms-paragraph'}>{rich_text(vnode.children)}</p>
    }
}
